import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cancelTokenArr: []// 请求路由数组
  },
  getters: {
  },
  mutations: {
    // 添加请求路由
    pushToken(state, payload) {
      state.cancelTokenArr.push(payload.cancelToken);
    },
    // 清空请求路由
    clearToken({
      cancelTokenArr
    }) {
      cancelTokenArr.forEach((item) => {
        item('路由跳转请求取消');
      });
      cancelTokenArr = [];
    }

  },
  actions: {},
  modules: {}
});